import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';
import { useUserCountry, useHasStripeAccount, useSetHasStripeAccount } from '../state';
import fetchWithToken from '../services';

const CreateStripeAccount = () => {
    console.log('Rendering CreateStripeAccount component');
    const userCountry = useUserCountry();
    const hasStripeAccount = useHasStripeAccount();
    const setHasStripeAccount = useSetHasStripeAccount();

    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const hasCreatedAccount = useRef(false);

    const createStripeAccount = useCallback(async () => {
        if (hasStripeAccount) return;
        setIsLoading(true);

        try {
            const stripeResponse = await fetchWithToken('/create-stripe-account', {
                method: 'POST',
                body: JSON.stringify({ country: userCountry }),
            });
            if (!stripeResponse.ok) {
                throw new Error('Failed to create Stripe account');
            }
            const data = await stripeResponse.json();
            console.log('Stripe account created successfully: ', data);
            setHasStripeAccount(true);
        } catch (error) {
            hasCreatedAccount.current = false;
            console.error('Error creating Stripe account:', error);
            navigate('/error');
        } finally {
            setIsLoading(false);
        }
    }, [hasStripeAccount]);

    useEffect(() => {
        if (!hasStripeAccount && !hasCreatedAccount.current) {
            hasCreatedAccount.current = true;
            createStripeAccount();
        }
    }, [hasStripeAccount]);

    if (isLoading) {
        return <Loading />;
    } else {
        return null;
    }
};

export default CreateStripeAccount;